import styles from './SSkeletonBodyText.module.css';

export function SSkeletonBodyText({ lines = 3, minWidth }: SSkeletonBodyTextProps) {
    const bodyTextLines = [];

    for (let i = 0; i < lines; i++) {
        bodyTextLines.push(<div className={styles.SSkeletonBodyText} key={i} />);
    }

    return (
        <div className={styles.SSkeletonBodyTextContainer} style={{ minWidth: minWidth ?? undefined }}>
            {bodyTextLines}
        </div>
    );
}

export interface SSkeletonBodyTextProps {
    /**
     * @default 3
     */
    lines?: number;
    minWidth?: `${number}px` | `${number}ch`;
}
